import { inject, provide, ref } from "vue";

import { CustomizationRecord } from "./customizations";

const injectKey = Symbol();

export function useTenantCustomizations(provideState = false) {
  const fields = ref<CustomizationRecord[]>([]);
  const loading = ref(false);

  async function fetchCustomizationValues() {
    loading.value = true;
    return new Promise((resolve) => {
      $.ajax("/customizations.json", {
        type: "GET",
        success: (res) => {
          loading.value = false;
          fields.value = res;
          resolve(void 0);
        }
      });
    });
  }

  function getValue(key: string) {
    const field = fields.value.find((field) => field.key === key);
    if (field) return field.value || field.default;
    return "";
  }

  async function handleChange(field: CustomizationRecord, value: string) {
    return new Promise((resolve, reject) => {
      if (field.key.indexOf("_color") > -1 || field.data_type === "color") {
        // Validate hex codes
        if (value.indexOf("#") !== 0) {
          // Show error
          return reject("Invalid HEX code (value must start with #)");
        }
      }
      $.ajax(`/customizations/${field.key}.json`, {
        type: "PUT",
        dataType: "JSON",
        data: {
          customization: {
            key: field.key,
            value
          }
        },
        success: () => {
          fetchCustomizationValues().then(() => resolve(void 0));
        },
        error: (e) => {
          reject();
        }
      });
    });
  }

  async function handleReset(field: CustomizationRecord) {
    return new Promise((resolve, reject) => {
      $.ajax(`/customizations/${field.key}.json`, {
        type: "DELETE",
        success: () => {
          fetchCustomizationValues().then(() => resolve(void 0));
        },
        error: (e) => {
          reject();
        }
      });
    });
  }

  const tenantCustomizationInterface = {
    fields,
    fetchCustomizationValues,
    getValue,
    handleChange,
    handleReset,
    loading
  };

  if (provideState) provide(injectKey, tenantCustomizationInterface);

  return tenantCustomizationInterface;
}

export const injectUseTenantCustomization = () =>
  inject<ReturnType<typeof useTenantCustomizations>>(injectKey)!;
